import gql from "graphql-tag";

export const RESET_DASHBOARD_LAYOUT = gql`
  mutation {
    resetDashboardLayouts
  }
`;
